module.exports = __webpack_public_path__ + "static/img/instagram.457a8b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/instagram.png
// module id = 2Uk2
// module chunks = 0